<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-xl-left text-muted">
          &copy; {{ year }}
          <a
            href="https://www.iripple.com/"
            class="font-weight-bold ml-1"
            target="_blank"
            >Powered by iRipple, Inc.</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
